module.exports = __webpack_public_path__ + "static/media/front-page-poster.8a8a2cd7.webp";